import { render } from "./UnauthenticatedLayout.vue?vue&type=template&id=5f223628&scoped=true"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=js"

import "./UnauthenticatedLayout.vue?vue&type=style&index=0&id=5f223628&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f223628"]])

export default __exports__